import { StandardAuthResponseType } from 'src/app/billing/shared/types/standard-auth-response.js';

export const StandardAuthResponse: StandardAuthResponseType = {
    data: null,
    status: 0,
    url: '',
    headers: {},
    success: false,
};

export default StandardAuthResponse;
